import Vue from 'vue';

Vue.component("location-google-map-component", {
    props: {
        mapCenterLat: Number,
        mapCenterLong: Number,
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            map: null
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.init();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        init() {
            EventBus.$once("google-maps-ready", this.initMap);

            this.intersect();
        },

        /**
         * Initialize the Google Map
         *
         * @return {Void}
         */
        initMap() {

            const mapStyle = [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": "0"
                        },
                        {
                            "lightness": "28"
                        },
                        {
                            "color": "#545456"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "-24"
                        },
                        {
                            "saturation": "0"
                        },
                        {
                            "gamma": "1"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "-5"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "15"
                        },
                        {
                            "weight": 1.2
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "0"
                        },
                        {
                            "gamma": "0.95"
                        },
                        {
                            "saturation": "0"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "-10"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "5"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "10"
                        },
                        {
                            "weight": 0.2
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "0"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "-93"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#1d1e21"
                        },
                        {
                            "lightness": "15"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": "-5"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                }
            ];

            this.map = new google.maps.Map(document.getElementById("gmap"), {
                zoom: 14,
                center: { lat: this.mapCenterLat, lng: this.mapCenterLong },
                styles: mapStyle,
                scrollwheel: false,
                streetViewControl: false,
                disableDefaultUI: true,
                mapTypeControl: false,
                scaleControl: false,
                fullscreenControl: false,
                backgroundColor: '#1d1e21'
            });

            const markerImg = document.createElement('img');
            markerImg.src = '/media/images/marker.svg';

            const latlng = new google.maps.LatLng(this.mapCenterLat, this.mapCenterLong);
            const marker = new google.maps.Marker({
                position: latlng,
                map: this.map,
                icon: "/media/images/pointer.svg"
            });
        },

        intersect() {

            const options = {
                rootMargin: "300px",
                threshold: 0
            };

            const map = document.getElementById("map-holder");

            const observerMap = new IntersectionObserver((entries, observer) => {
                const isIntersecting =
                    typeof entries[0].isIntersecting === "boolean"
                        ? entries[0].isIntersecting
                        : entries[0].intersectionRatio > 0;
                if (isIntersecting) {
                    this.injectGoogleMaps();
                    observer.unobserve(map);
                }
            }, options);

            observerMap.observe(map);
        },

        /**
         * Injects the Google Maps scripts when it is not there yet.
         *
         * @return {Void}
         */
        injectGoogleMaps() {
            const tag = document.createElement("script");
            tag.setAttribute("type", "text/javascript");
            tag.defer = true;
            tag.async = true;
            tag.setAttribute(
                "src",
                "//maps.google.com/maps/api/js?key=AIzaSyDo9CCCFW4cogk1nDst_EPBSRGl_rhkxcM&callback=mapsCallback"
            );
            (
                document.getElementsByTagName("head")[0] ||
                document.documentElement
            ).appendChild(tag);
        },

        /**
         * Raised when zoom in button of the map is clicked.
         *
         * @param   {Event}
         * @returns {Void}
         */
        onMapZoomInClick(event) {
            this.map.setZoom(this.map.getZoom() + 1);
        },

        /**
         * Raised when the zoom out button of the map is clicked.
         *
         * @param {Event} event
         * @returns {Void}
         */
        onMapZoomOutClick(event) {
            this.map.setZoom(this.map.getZoom() - 1);
        },
    }
});
